import React from 'react';

const EditableContext = React.createContext(null);

export default EditableContext;
